/*
 * @Description: 
 * @Author: beiweiping
 * @Date: 2019-05-05 10:45:09
 * @LastEditTime: 2019-06-17 11:14:47
 * @LastEditors: beiweiping
 */
import Vue from 'vue'

//过滤器,去掉小数点后面的0
Vue.filter('filterNumber', function (number) {
  if (!number || typeof (number) == 'undefined') {
    if (number == 0) {
      return 0;
    }
    return ''
  }
  return parseFloat(number);
});

//日期格式化
Date.prototype.format = function(fmt){
  var o = {
    "M+" : this.getMonth()+1,                 //月份
    "d+" : this.getDate(),                    //日
    "h+" : this.getHours(),                   //小时
    "m+" : this.getMinutes(),                 //分
    "s+" : this.getSeconds(),                 //秒
    "q+" : Math.floor((this.getMonth()+3)/3), //季度
    "S"  : this.getMilliseconds()             //毫秒
  };
  if(/(y+)/.test(fmt))
  fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(var k in o)
  if(new RegExp("("+ k +")").test(fmt))
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
  return fmt;
}
//身份证号，展示1+*+1的方式
Vue.filter('filterIdCard', function (number) {
  if (!number) {
    return ''
  }
  return number.substr(0, 1) + "****************" + number.substr(17);
});
// 手机号码，展示3+*+4的方式
Vue.filter('filterPhone', function (number) {
  if (!number) {
    return ''
  }
  return number.substr(0, 3) + "****" + number.substr(7);
});

//小数点打0显示
Vue.filter('filterPoint', function (number) {
  if (typeof (number) == "string") {
    number = parseFloat(number);
  }
  if (typeof (number) == "undefined") {
    return "0.00";
  }
  if (number == 0 || number == -1) {
    return "0.00";
  }
  return number.toFixed(2);
});

/*
 * filterCutstr 函数是截取字符串;
 * 2个必传参数
 * @str    需要截取的字符串
 * @len    需要截取的长度（中文占2个）
 * @return {字符串} str新的字符串
 */
Vue.filter('filterCutstr', function (str, len) {
  var str_length = 0;
  var str_len = 0;
  var str_cut = new String();
  str_len = str.length;
  for (var i = 0; i < str_len; i++) {
    var a = str.charAt(i);
    str_length++;
    if (escape(a).length > 4) {
      //中文字符的长度经编码之后大于4
      str_length++;
    }
    str_cut = str_cut.concat(a);
    if (str_length > len) {
      str_cut = str_cut.substring(0, str_cut.length - 1).concat("...");
      return str_cut;
    }
  }
  //如果给定字符串小于等于指定长度，则返回源字符串；
  if (str_length <= len) {
    return str;
  }
});

/**
 * 格式化一周日期  
 * 用法
 *  {{times | filterFormatDate()}}
 */
Vue.filter('filterDay',function(time){
  if(!time){
    return '';
  }
  let newDate=new Date(time),
   week =newDate.getDay(),
   str='';
   if (week == 0) {  
        str = "星期日";  
    } else if (week == 1) {  
        str = "星期一";  
    } else if (week == 2) {  
        str = "星期二";  
    } else if (week == 3) {  
        str = "星期三";  
    } else if (week == 4) {  
        str = "星期四";  
    } else if (week == 5) {  
        str = "星期五";  
    } else if (week == 6) {  
        str = "星期六";  
    }  
    return str;
})

/**
 * 转换时间格式的过滤器
 * 用法：
 * times = 1489895605000
 * {{times | filterFormatDate('yyyy-MM-dd hh:mm:ss')}}
 * @param time 毫秒数
 * @param fmt 要转换的时间格式
 */
Vue.filter('filterFormatDate', function (time, fmt) {
  if (!time) {
    return '';
  }
  let newDate = new Date(time),
    Y = newDate.getFullYear(),
    M = format(newDate.getMonth() + 1),
    D = format(newDate.getDate()),
    h = format(newDate.getHours()),
    m = format(newDate.getMinutes()),
    s = format(newDate.getSeconds());

  function format(data) {
    if (data.toString().length < 2) {
      data = '0' + data;
    }
    return data
  };
  let timeStr = '';
  switch (fmt) {
    case "yyyy-MM-dd hh:mm:ss":
      timeStr = Y + "-" + M + "-" + D + "  " + h + ":" + m + ":" + s;
      break;
    case "yyyy-MM-dd hh:mm":
      timeStr = Y + "-" + M + "-" + D + "  " + h + ":" + m;
      break;
    case "yyyy-MM-dd":
      timeStr = Y + "-" + M + "-" + D;
      break;
    case "MM-dd hh:mm:ss":
      timeStr = M + '月' + D + '日 ' + ' ' + h + '时' + m + '分' + s + '秒';
      break;
    case "MM-dd hh:mm":
      timeStr = M + "." + D + "  " + h + ":" + m;
      break;
    case "MM-dd":
      timeStr = M + "月" + D + "日";
      break;
    case "MM-dd hh-mm-ss":
      timeStr = M + '月' + D + '日' + ' ' + h + ':' + m + ':' + s;
      break;
    case "MM-dd hh-mm":
      timeStr = M + '月' + D + '日' + ' ' + h + '点' + m + '分';
      break;
    case "MM:dd hh:mm":
      timeStr = M + '月' + D + '日' + ' ' + h + ':' + m + ' ';
      break;
    case "MM月dd日 hh:mm":
      timeStr = M + '月' + D + '日' + ' ' + h + ':' + m + ' ';
      break;
    case "YY年MM月DD日":
      timeStr=Y + '年' + M + '月' + D +'日';
      break; 
    case "yyyy.MM.dd":
      timeStr = Y + '.' + M + '.' + D +' ';
      break;  
    case "yyyy.MM.dd hh:mm":
      timeStr = Y + '.' + M + '.' + D + ' ' + h + ':' + m + ' ';
      break;
    default:
      timeStr = Y + "-" + M + "-" + D + "  " + h + ":" + m + ":" + s;
      break;
    case "MM/dd hh:mm":
      timeStr = M + '/' + D + ' ' + h + ':' + m + ' ';
      break;
    case "hh:mm":
      timeStr=h +':' +m +' ';
      break;  
  }
  return timeStr;
});